import { render } from "./produceIndex.vue?vue&type=template&id=229a726b&scoped=true"
import script from "./produceIndex.vue?vue&type=script&lang=js"
export * from "./produceIndex.vue?vue&type=script&lang=js"

import "./produceIndex.vue?vue&type=style&index=0&id=229a726b&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-229a726b"]])

export default __exports__